var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14.306,
    viewBox: "0 0 24 14.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M12,98.725c-4.585,0-8.744,2.509-11.812,6.584a.95.95,0,0,0,0,1.134c3.068,4.08,7.227,6.589,11.812,6.589s8.744-2.509,11.812-6.584a.95.95,0,0,0,0-1.134C20.744,101.234,16.585,98.725,12,98.725Zm.329,12.19a5.048,5.048,0,1,1,4.708-4.708A5.051,5.051,0,0,1,12.329,110.915Zm-.152-2.327a2.718,2.718,0,1,1,2.538-2.538A2.714,2.714,0,0,1,12.177,108.588Z",
    transform: "translate(0 -98.725)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.a85f7fc376d5610fddd21dff517e021f.svg";
export { ForwardRef as ReactComponent };